const urls = {
  getAvatar: '/users/profile/avatar/get',
} as const;

export default urls;
